

export const environment = {
    production: false,
    baseUrl: 'https://api-kyisignxea-uc.a.run.app',
    EmailServiceUrl: 'https://us-central1-co-solution-dev.cloudfunctions.net/sendEmail',
    firebase: {
        apiKey: "AIzaSyAD9L9qb4NeG0sBwVOnTOLVSwo7aKH3WR0",
        authDomain: "co-solution-dev.firebaseapp.com",
        projectId: "co-solution-dev",
        storageBucket: "co-solution-dev.firebasestorage.app",   
        messagingSenderId: "104232822047",
        appId: "1:104232822047:web:6c04849b43483fc485fc2a",
        measurementId: "G-H9HJYWSNF0"
      }
  };
